import { render, staticRenderFns } from "./AuditsDetailModal.vue?vue&type=template&id=4bfb1afb&scoped=true"
import script from "./AuditsDetailModal.vue?vue&type=script&lang=js"
export * from "./AuditsDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb1afb",
  null
  
)

export default component.exports